import { createDocValueStore } from './docStore';

// WHICH OF HARDWARE & COVERS' THREE TABS IS OPEN — the joints table, the 3D models or the
// insertion table. Set by the strip that holds them (PartsPhase) and read by the phase's row of
// badges (ModelsPhase), which greys the ones that are not about the tab on screen.
export type HardwareTab = 'table' | 'models' | 'axis';

const store = createDocValueStore<HardwareTab>('models');
export const useHardwareTab = store.useValue;
export const setHardwareTab = store.set;
